
import { Guard } from "../../types";
import { useTeamManagement } from "./useTeamManagement";
import { AssignedTeams } from "./AssignedTeams";
import { TeamSelector } from "./TeamSelector";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useUserRoles } from "@/hooks/useUserRoles";

interface TeamManagementProps {
  guard: Guard;
  onTeamChange?: () => void;
}

export const TeamManagement = ({ guard, onTeamChange }: TeamManagementProps) => {
  const {
    teams,
    guardTeams,
    isLoading,
    showConfirmDialog,
    pendingTeamAction,
    handleTeamAction,
    handleConfirmAction,
    setShowConfirmDialog,
    setPendingTeamAction
  } = useTeamManagement(guard, onTeamChange);
  
  const { isAdmin } = useUserRoles();

  const handleCancelAction = () => {
    setShowConfirmDialog(false);
    setPendingTeamAction(null);
  };

  return (
    <div>
      <AssignedTeams
        guardTeams={guardTeams}
        isLoading={isLoading}
      />
      
      {/* Only show team assignment options for admin users */}
      {isAdmin && (
        <TeamSelector
          teams={teams}
          guardTeams={guardTeams}
          onTeamAction={handleTeamAction}
        />
      )}

      <AlertDialog open={showConfirmDialog} onOpenChange={setShowConfirmDialog}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>
              Confirm Team {pendingTeamAction?.isAssign ? 'Assignment' : 'Unassignment'}
            </AlertDialogTitle>
            <AlertDialogDescription>
              Are you sure you want to {pendingTeamAction?.isAssign ? 'assign' : 'unassign'} the guard {guard.first_name} {guard.last_name} {pendingTeamAction?.isAssign ? 'to' : 'from'} team "{pendingTeamAction?.teamName}"?
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={handleCancelAction}>Cancel</AlertDialogCancel>
            <AlertDialogAction 
              onClick={handleConfirmAction}
              className={pendingTeamAction?.isAssign ? 'bg-primary' : 'bg-destructive hover:bg-destructive/90'}
            >
              Confirm
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};
